import { render, staticRenderFns } from "./TabSharedPresentations.vue?vue&type=template&id=23e9d818&"
import script from "./TabSharedPresentations.vue?vue&type=script&lang=js&"
export * from "./TabSharedPresentations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports